<script setup lang="ts">
import { ArrowLeftIcon } from 'lucide-vue-next'

const { t } = useI18n()
const router = useRouter()
</script>

<template>
  <div class="text-primary flex items-center gap-2 cursor-pointer w-fit" @click="router.back()">
    <ArrowLeftIcon :size="18" />
    <span class="font-semibold text-sm">
      {{ t('global.back') }}
    </span>
  </div>
</template>
